/**
 * External dependencies
 */
import inherits from 'inherits';

export default class RoamPlan {
    
    constructor(cscom) {
        if (!(this instanceof RoamPlan)) {
            return new RoamPlan(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/roam-plans/list', null, data);
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/roam-plans/view', null, data);
    }    
}
